<script setup>
// Уся «обв'язка» основного сайту живе тут, а не в app.vue: сторінка /live
// використовує власний layout і не має тягнути ні навбар, ні пінги онлайну,
// ні віджети чату сайту.
const nuxtApp = useNuxtApp()
const loading = useState('loading', () => false)

// Лічильник живого онлайну (сайт + аніме/епізод, коли відкрита сторінка перегляду)
useOnlinePresence()

const isOnline = ref(true)
const needsUpdate = ref(false)
const updatePWA = () => {
  if (import.meta.client) {
    window.location.reload()
  }
}

onMounted(() => {
  if (import.meta.client) {
    useNuxtApp().$pwa?.install()

    // Ініціалізуємо PWA
    const pwa = usePWA()
    if (pwa) {
      watch(pwa.isOnline, (val) => {
        isOnline.value = val
      })
      watch(pwa.needsUpdate, (val) => {
        needsUpdate.value = val
      })
    }

    nuxtApp.hook('page:start', () => {
      loading.value = true
    })
    nuxtApp.hook('page:finish', () => {
      loading.value = false
    })
  }
})
</script>

<template>
  <div>
    <Transition name="fade">
      <div
        v-if="loading"
        class="top-0 left-0 z-50 fixed flex justify-center items-center bg-black bg-opacity-50 backdrop-blur-sm w-full h-full"
      >
        <img
          src="/minloading.webp"
          class="rounded-full overflow-hidden"
          preload
          width="40"
          height="40"
          alt="logo"
        />
      </div>
    </Transition>

    <!-- Navbar is outside NuxtPage so it never gets caught by page transitions -->
    <MyNavbar />
    <main>
      <div class="">
        <slot />
      </div>
    </main>
    <SiteChatWidget />
    <ClientOnly>
      <DownloadToast />
      <CookieConsent />

      <!-- PWA Update Banner -->
      <Transition name="slide-up">
        <div
          v-if="needsUpdate"
          class="right-4 bottom-4 left-4 z-50 fixed flex justify-between items-center gap-4 bg-primary shadow-lg p-4 rounded-lg text-primary-content"
        >
          <div class="flex-1">
            <p class="font-medium">Доступне оновлення</p>
            <p class="opacity-80 text-sm">
              Нова версія додатку готова до встановлення
            </p>
          </div>
          <button
            @click="updatePWA"
            class="btn btn-sm btn-ghost"
          >
            Оновити
          </button>
        </div>
      </Transition>

      <!-- Offline Indicator -->
      <Transition name="slide-up">
        <div
          v-if="!isOnline"
          class="right-4 bottom-4 left-4 z-50 fixed flex justify-center items-center gap-2 bg-warning shadow-lg p-3 rounded-lg text-warning-content"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line
              x1="1"
              y1="1"
              x2="23"
              y2="23"
            ></line>
            <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path>
            <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path>
          </svg>
          <span class="font-medium text-sm">Офлайн режим</span>
        </div>
      </Transition>
    </ClientOnly>
  </div>
</template>
